import { Activity, ShieldCheck, Scale, Trophy } from "lucide-react";

const ICONS = { injury: Activity, coverage: ShieldCheck, liability: Scale, overall: Trophy };

export function ScoreCard({ score, big }) {
  if (!score) return null;
  const Icon = ICONS[score.category] || Activity;
  return (
    <div className={`bg-white rounded-3xl border border-slate-100 p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] overflow-hidden relative ${big ? "md:col-span-3" : ""}`} data-testid={`score-card-${score.category}`}>
      <div className="absolute top-0 left-0 right-0 h-1.5" style={{ backgroundColor: score.color }} />
      <div className="flex items-center gap-2 text-slate-500">
        <Icon className="w-4 h-4" style={{ color: score.color }} />
        <span className="text-xs font-semibold uppercase tracking-wider">{score.label}</span>
      </div>
      <div className="mt-4 flex items-end gap-3">
        <div className={`font-heading font-extrabold leading-none ${big ? "text-6xl" : "text-5xl"}`} style={{ color: score.color }}>{score.score}<span className="text-2xl text-slate-300">/100</span></div>
        <div className="mb-1 px-3 py-1 rounded-full text-white font-heading font-bold text-lg" style={{ backgroundColor: score.color }} data-testid={`score-grade-${score.category}`}>{score.grade}</div>
      </div>
      <div className="mt-4 h-2 rounded-full bg-slate-100 overflow-hidden">
        <div className="h-full rounded-full transition-all duration-700" style={{ width: `${score.score}%`, backgroundColor: score.color }} />
      </div>
      <p className="mt-4 text-sm text-slate-600 leading-relaxed">{score.explanation}</p>
    </div>
  );
}

export function ScoreCards({ scores }) {
  if (!scores) return null;
  return (
    <div className="grid md:grid-cols-3 gap-5">
      {scores.overall && <ScoreCard score={scores.overall} big />}
      <ScoreCard score={scores.injury} />
      <ScoreCard score={scores.coverage} />
      <ScoreCard score={scores.liability} />
    </div>
  );
}
